import './CreateSystemPassword.css';

import React, { useState } from 'react';
import { type PasswordTarget } from '@src/ConfigInfo';
import { messageBox } from '@src/style/style';
import { setNewPassword } from './passwordApi';
import { PasswordInput, ConfirmPasswordButton, SkipSystemPasswordOnboardingButton } from './components';

interface CreateSystemPasswordProps {
  onPasswordCreated: () => void
  passwordTargets: PasswordTarget[]
  onSkipPassword: () => void
}

export const CreateSystemPassword = ({ onPasswordCreated, passwordTargets, onSkipPassword }: CreateSystemPasswordProps): JSX.Element => {
  const [password, setPassword] = useState('');
  const [confirmedPassword, setConfirmedPassword] = useState('');
  const [isSettingPassword, setIsSettingPassword] = useState(false);
  const [hasPasswordCreationFailed, setHasPasswordCreationFailed] = useState(false);

  const completeSystemPasswordOnboarding = (): void => {
    setIsSettingPassword(true);

    setNewPassword(passwordTargets, password, confirmedPassword, '')
      .then(() => {
        setIsSettingPassword(false);

        messageBox('Password set', 'success');
        onPasswordCreated();
      })
      .catch((errors: string[]) => {
        setIsSettingPassword(false);
        setHasPasswordCreationFailed(true);

        errors.forEach((error, index) => { messageBox(error, 'warning', { timeOut: 5000 + index * 1000 }); });
      });
  };

  const canSetPassword = !isSettingPassword &&
    password !== '' &&
    password === confirmedPassword;

  return (
    <div id="create_system_password_onboarding_content">
      <div id="create_system_password_onboarding_content_prompts">
        <div id="create_system_password_onboarding_content_title">Create a System Password to Secure your Vention Devices</div>
        <div id="create_system_password_onboarding_content_message">Your Vention devices are configured with a default password. To secure information on your devices we must protect them with a new password (this is not your Vention account password). This password can be changed in the future through Cloud9, for help doing this, contact us at +1-800-940-3617 or integrationsupport@vention.cc</div>
      </div>
      <div id="create_system_password_onboarding_content_controls">
        <PasswordInput label="Password" onChange={setPassword} />
        <PasswordInput label="Confirm Password" onChange={setConfirmedPassword} />
        <ConfirmPasswordButton
          label="Set System Password"
          onClick={completeSystemPasswordOnboarding}
          disabled={!canSetPassword}
        />
        {hasPasswordCreationFailed ? <SkipSystemPasswordOnboardingButton onClick={onSkipPassword} /> : null}
      </div>
    </div>
  );
};
